document.addEventListener('DOMContentLoaded', function () {
    gsap.registerPlugin(ScrollTrigger);

    const imageScroll = document.querySelector('.custom-feedback-form__image-scroll');
    const form = document.querySelector('.custom-feedback-form');
    
    if (!form) return;
    ScrollTrigger.create({
        trigger: ".custom-feedback-form",
        start: () => form.offsetHeight <= window.innerHeight ? "top top" : "bottom bottom",
        endTrigger: ".section-community-winner-wrap",
        end: "bottom bottom",
        pin: true,
        pinSpacing: false,
        invalidateOnRefresh: true 
    });

    if (imageScroll) {
        ScrollTrigger.create({
            trigger: ".text-stage",
            start: "top bottom", 
            onEnter: () => imageScroll.classList.add('active'),
            onLeaveBack: () => imageScroll.classList.remove('active'),
            invalidateOnRefresh: true
        });
    }

    ScrollTrigger.create({
        trigger: ".text-stage",
        start: "top top",
        endTrigger: ".community-winner",
        end: "top top",
        pin: true,
        pinSpacing: false,
        invalidateOnRefresh: true
    });
});
window.addEventListener('load', function () {
    ScrollTrigger.refresh();
});